export default {
    allStatus: 'All Status',
    searchByEmployeeNoOrName: 'Search by Employee No or Name',
    statusAttendance: 'Status Attendance',
    absent: 'Absent',
    leaveFullday: 'Leave Fullday',
    leaveHalfday: 'Leave Halfday',
    present: 'Present',
    late: 'Late',
    onsiteFullday: 'Onsite Fullday',
    onsiteHalfday: 'Onsite Halfday',
    search: 'Search',
    employeeNo: 'Employee No',
    name: 'Full Name',
    startDate: 'Start Date',
    endDate: 'End Date',
    date: 'Date',
    status: 'Status',
    ciType: 'Type (In)',
    ciTime: 'Time In',
    coType: 'Type (Out)',
    coTime: 'Time Out',
    terminalIn: 'Terminal (In)',
    terminalOut: 'Terminal (Out)',
    totalHours: 'Total Hours',
    note: 'Note: Olaf will calculate Total Hours based on First Time In to Last Time Out'
}
